export default "__VITE_ASSET__d95f2f53__"